import React from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { ModeratorLogKind } from "@/const";

export default function ModeratorLogKindDisplay({ kind }) {
    const { t } = useTranslation();
    switch (kind) {
        case ModeratorLogKind.SERVICE:
            return <Badge variant="warning">{t("служебное")}</Badge>;
        case ModeratorLogKind.FROM_DEVELOPER:
            return <Badge variant="success">{t("от разработчика")}</Badge>;
        case ModeratorLogKind.TO_DEVELOPER:
            return <Badge variant="info">{t("разработчику")}</Badge>;
        default:
            return null;
    }
}
